import React from "react";

export const IconPowerOn = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M12 2v8M6.35 6.35a8 8 0 1011.3 0"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const IconPowerOff = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <line
      x1="8"
      y1="8"
      x2="16"
      y2="16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconRestart = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M21 12a9 9 0 10-3.3 6.9M21 12h-6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const IconLogout = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M10 17l5-5-5-5M15 12H3M21 3v18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const IconDelete = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const MenuIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M4 6h16M4 12h16M4 18h16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconMigrate = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M4 7h10l-3-3m3 3l-3 3M20 17H10l3 3m-3-3l3-3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconInternet = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2c4 4 4 16 0 20M12 2c-4 4-4 16 0 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconInternetOff = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <line
      x1="5"
      y1="5"
      x2="19"
      y2="19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
